import { render, staticRenderFns } from "./LiveBookModal.vue?vue&type=template&id=4ecabb4c&lang=pug&"
import script from "./LiveBookModal.vue?vue&type=script&lang=js&"
export * from "./LiveBookModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports